module.exports = __webpack_public_path__ + "img/logo_floa.10ed2aae.svg";